import React, { useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { PrimaryButton } from 'office-ui-fabric-react';
import get from 'lodash/get';
import { fetchContractActivity } from '../../actions/contracts';
import TextButton from '../../components/TextButton';
import ContractTermsForm from '../../components/ContractTermsForm';
import Module from '../../components/Module';
import ModuleHeader from '../../components/ModuleHeader';
import ModuleContent from '../../components/ModuleContent';
import Main from '../../components/Main';
import PageTitle from '../../components/PageTitle';
import ContractActionRequired from '../../components/ContractActionRequired';
import styles from './ReviewContractTerms.style';

const ReviewContractTerms = () => {
  const history = useHistory();
  const ref = useRef();
  const dispatch = useDispatch();
  const { contractAddress } = useParams();
  const contract = useSelector(state => get(state, `entities.contracts.${contractAddress}`, {}));

  useEffect(() => {
    dispatch(fetchContractActivity(contractAddress));
  }, [dispatch, contractAddress]);

  // check contract approvalStatus to see if this page is even viewable.
  // If it's not pending initial approval then users should not be able to see it.
  useEffect(() => {
    if (contract.approvalStatus && contract.approvalStatus !== 'PendingInitialApproval') {
      history.push(`/contracts/${contractAddress}`);
    }
  }, [history, contract.approvalStatus, contractAddress]);

  const handleCancel = () => {
    history.push(`/contracts/${contractAddress}`);
  };

  const handleContinue = () => {
    history.push(`/contracts/${contractAddress}/approve/royalty-fees`);
  };

  return (
    <>
      <PageTitle>Approve Contract</PageTitle>

      <Main>
        <ContractActionRequired
          address={contractAddress}
          hideCta
          className={styles.actionRequired}
        />

        <Module>
          <ModuleHeader variant="xLarge">
            <span className={styles.moduleHeaderText}>Contract Terms</span>
          </ModuleHeader>

          <ModuleContent>
            <ContractTermsForm address={contractAddress} ref={ref} reviewMode />
          </ModuleContent>
        </Module>

        <div className={styles.buttonContainer}>
          <TextButton className={styles.cancelButton} onClick={handleCancel}>
            Cancel
          </TextButton>
          <PrimaryButton type="submit" onClick={handleContinue}>
            Continue
          </PrimaryButton>
        </div>
      </Main>
    </>
  );
};

export default ReviewContractTerms;
